import { render } from "./Header.vue?vue&type=template&id=4ba775bc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.scss?vue&type=style&index=0&id=4ba775bc&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba775bc"]])

export default __exports__